import { RouteRecordRaw } from 'vue-router'
import { metaDataAuthGuard } from '@shared/guards/auth'
import { AuthScope, PermissionLevel } from '@shared/stores/auth'
import type { ExtractRouteNames } from '@shared/types/RouteNames'

// components
const UserTargetsHome = () => import(/* webpackChunkName: "UserTargetsHome" */'@targets/views/UserTargetsHome.vue')
const UserTargetsActuals = () => import(/* webpackChunkName: "UserTargetsActuals" */ '@targets/views/UserTargetActuals.vue')
const UserTargets = () => import(/* webpackChunkName: "UserTargets" */ '@targets/views/UserTargets.vue')

// Targets routes
export const routes = {
  path: '/user-targets',
  name: 'UserTargets',
  component: UserTargetsHome,
  beforeEnter: metaDataAuthGuard,
  meta: {
    requiredScopes: [{ level: PermissionLevel.Read, scope: AuthScope.UserTargets }],
  },
  redirect: { name: 'UserTargetsManage' },
  children: [
    {
      path: 'manage',
      name: 'UserTargetsManage',
      beforeEnter: metaDataAuthGuard,
      component: UserTargets,
    },
    {
      path: 'actuals',
      name: 'UserTargetsActuals',
      beforeEnter: metaDataAuthGuard,
      component: UserTargetsActuals,
    },
  ] as const satisfies RouteRecordRaw[],
} as const satisfies RouteRecordRaw

export type UserTargetsRouteNames = ExtractRouteNames<typeof routes> | ExtractRouteNames<typeof routes.children[number]>

export default routes
